import EventManager from "../../store/sqftEventManager";
import CabinetShapes from "./cabinetShapes";
import store from "../../../../../../store";
import {setSQFTContextMenuV2} from "../../../../../../actions/sqftMenuFunctions";
import workspace from "../workspace";
import {renderMeasurementsAroundSnappedShapes} from "../slab/sqftSlabDraw";
import CabinetShapesLayout from "./cabinetShapesLayout";

const cabinetWorkspace = function() {
  this.eventManager = EventManager;
  this.objectName = {name: 'CabinetWorkspace'};
  this.state = {
    //inEnabled: false
  }
  this.cabinetShapes = new CabinetShapes();
  this.cabinetShapesLayout = new CabinetShapesLayout();
  this.measurementPoints = [];
  this.__crownMoldingParams = {
    distance: 10
  }

  this.initCabinetEvents = () => {
    EventManager.addEvent(
      EventManager.events.CONTEXTMENU,
      this.onRightClick,
      this,
      EventManager.priorities.OVERLAY
    );
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render,
      this,
      EventManager.priorities.OVERLAY
    );
  }

  this.render = (ctx) => {
    renderMeasurementsAroundSnappedShapes(ctx);
  }

  // this.getCrownMoldingPoints = (snappedShapeGroup) => {
  //   const points = this.getMeasurementPoints(snappedShapeGroup);
  //
  //   return RenderCabinets.getDiagonalPointsForTheSquare(points, this.__crownMoldingParams.distance)
  // }
  //
  // this.renderCrownMolding = (ctx, snappedShapeGroup) => {
  //   const shapes = sqftShapeManager.getSnappedShapes(snappedShapeGroup);
  //   let isShapeInFeatureGroupHasCrownMolding = false;
  //   if (shapes.length > 0) {
  //     isShapeInFeatureGroupHasCrownMolding = shapes.some(shp => {
  //       return !!shp.shapeCabinet.__crownMoldingFeatureId
  //     });
  //   }
  //
  //   if (isShapeInFeatureGroupHasCrownMolding) {
  //     const crownMoldingPoints = this.getCrownMoldingPoints(snappedShapeGroup);
  //     RenderCabinets.renderCrownMolding(ctx, crownMoldingPoints);
  //   }
  // };

  this.deregisterEvents = () => {
    EventManager.removeEvent(this);
  }

  this.onRightClick = (mousePos, e) => {
    console.log("e", e);
    console.log("mousePos", mousePos);
    store.dispatch(setSQFTContextMenuV2(
      {
        isOpened: true,
        title: workspace.intl.formatMessage({id: "sqft.contextmenu.properties.title"}),
        menuItems: [
          {
            title: 'Change Cabinet Style',
            callback: new Function()
          },
          {
            title: 'Generate Countertop',
            callback: new Function()
          },
          {
            title: 'Generate Backsplash',
            callback: new Function()
          },
        ],
        position: {left: mousePos.x, top: mousePos.y}
      }
    ));
    document.addEventListener('click', this.closeContextMenu)
  }

  this.closeContextMenu = (e) => {
    const navClick = e.target.closest('[class*="contextmenu2"]');
    if (!navClick && !window.touchMove) {
      store.dispatch(setSQFTContextMenuV2(
        {
          isOpened: false,
          title: '',
          menuItems: [],
          position: {}
        }
      ));
    }
  }
};

export default new cabinetWorkspace;
